// Check and send quiz view event
let quizViewEventSent = false;

function sendQuizViewEvent() {
  if (quizViewEventSent) return;

  if (typeof window.gtag === "undefined") {
    console.warn("GTM is not initialized yet");
    return false;
  }

  const targetSection = document.querySelector("#quiz-main-wrapper");
  if (!targetSection) {
    console.warn("Quiz section not found");
    return false;
  }

  let previousPages = [];
  try {
    const rawHistory = sessionStorage.getItem("quiz_path_history");
    if (rawHistory) {
      previousPages = JSON.parse(rawHistory);
    }
  } catch (e) {
    console.warn("Could not parse quiz_path_history:", e);
  }

  // Send the event to GTM
  gtag("event", "quiz_view", {
    quiz_step: "view",
    quiz_type: "shade_finder",
    previous_pages: JSON.stringify(previousPages),
  });

  // Clear the session storage
  sessionStorage.removeItem("quiz_path_history");
  console.log("✅ Quiz view event sent with path history");

  quizViewEventSent = true;
  return true;
}

// Try to send event when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // First attempt
  if (!sendQuizViewEvent()) {
    // If failed, try again after a short delay to ensure GTM is loaded
    setTimeout(sendQuizViewEvent, 1500);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const quizSteps = document.querySelectorAll(".quiz-wrapper");
  const progressSteps = document.querySelectorAll(".quiz-progress-step");
  const quizResults = [];
  let currentStep = 0;
  const restartButton = document.querySelectorAll(
    ".quiz_product__header--restart button"
  );
  const quizModal = document.querySelector("#quiz-modal");
  const quizModalContent = document.querySelector("#quiz-modal-text");
  const quizModalClose = document.querySelector(".quiz-modal__close");

  const resetQuiz = () => {
    // Reset current step
    currentStep = 0;

    // Clear quiz results
    quizResults.length = 0;

    // Reset inputs
    const inputs = document.querySelectorAll(
      ".quiz-answers input[type='radio'], .quiz-answers input[type='checkbox']"
    );
    inputs.forEach((input) => {
      input.checked = false;
    });

    // Reset active classes on steps
    quizSteps.forEach((step, index) => {
      step.classList.toggle("active", index === 0);
    });

    // Reset progress bar
    progressSteps.forEach((step, index) => {
      step.classList.remove("active", "completed");
      if (index === 0) {
        step.classList.add("active");
      }
    });

    // Hide product block
    const quizProductBlock = document.getElementById("quiz-product");
    if (quizProductBlock) {
      quizProductBlock.classList.add("hidden-product");
    }

    console.log("Quiz restarted");
  };

  // Attach event listener to the restart button
  restartButton.forEach((button) => {
    button.addEventListener("click", resetQuiz);
  });

  const openModal = (content) => {
    quizModalContent.innerHTML = content;
    quizModal.style.display = "flex";
  };

  const closeModal = () => {
    quizModal.style.display = "none";
  };

  quizModalClose.addEventListener("click", closeModal);

  document.addEventListener("click", (e) => {
    if (e.target === quizModal) {
      closeModal();
    }
  });

  const initializeModalButtons = () => {
    const infoButtons = document.querySelectorAll(".quiz-info__button");
    infoButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const infoContent =
          button.closest(".quiz-info")?.nextElementSibling?.innerHTML;
        if (infoContent) {
          openModal(infoContent);
        } else {
          console.warn("No content found for modal.");
        }
      });
    });
  };

  const updateProgressBar = () => {
    progressSteps.forEach((step, index) => {
      step.classList.remove("active", "completed");
      if (index < currentStep) {
        step.classList.add("completed");
      } else if (index === currentStep) {
        step.classList.add("active");
      }
    });
  };

  const showStep = (step) => {
    quizSteps.forEach((stepElement, index) => {
      stepElement.classList.toggle("active", index === step);
    });
    updateProgressBar();
    initializeScrollButtonsForStep(step);
  };

  const updateButtonState = (step) => {
    const stepElement = quizSteps[step];
    const inputs = stepElement.querySelectorAll("input");
    const nextButton = stepElement.querySelector(".next-button");
    nextButton.disabled = !Array.from(inputs).some((input) => input.checked);
  };

  const updatePreviousButtonState = (step) => {
    const previousButton = quizSteps[step]?.querySelector(".previous-button");
    if (previousButton) {
      previousButton.disabled = step === 0;
    }
  };

  const saveStepResult = (step) => {
    const stepElement = quizSteps[step];
    const questionText =
      stepElement.querySelector(".quiz-question h2").textContent;
    const inputs = stepElement.querySelectorAll("input");

    const answers = Array.from(inputs)
      .filter((input) => input.checked)
      .map((input) => ({
        value: input.value,
        options:
          input
            .closest(".quiz-answer")
            .dataset.options?.split(";")
            .map((opt) => opt.trim()) || [],
      }));

    quizResults[step] = { question: questionText, answers };
  };

  const computeOptionCounts = () => {
    const optionCounts = {};

    quizResults.forEach((result) => {
      result.answers.forEach((answer) => {
        answer.options.forEach((option) => {
          if (option) {
            optionCounts[option] = (optionCounts[option] || 0) + 1;
          }
        });
      });
    });

    const sortedOptionCounts = Object.entries(optionCounts).sort(
      ([, countA], [, countB]) => countB - countA
    );

    const mostPopularColor = sortedOptionCounts.find(([option]) =>
      option.toLowerCase().includes("shade")
    )?.[0];

    // Send to Google Analytics after quiz completion
    if (window.gtag) {
      gtag("event", "quiz_completion", {
        quiz_step: "completed",
        shade_selected: mostPopularColor || "Not Selected",
        quiz_type: "shade_finder",
      });
      console.log("✅ Quiz completion event sent to Google Analytics", {
        shade_selected: mostPopularColor || "Not Selected",
      });
    } else {
      console.warn("❌ GTM undefined");
    }

    selectColorAndSize(mostPopularColor);
    console.log("Most Popular Color:", mostPopularColor || "None");
  };

  const showProduct = () => {
    const productWrapper = document.querySelector("#quiz-product");
    if (productWrapper) {
      productWrapper.classList.remove("hidden-product");
      setTimeout(() => {
        productWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  };

  const selectColorAndSize = (color) => {
    if (!color) return;

    // Update the color result text in the quiz header
    const productQuizColorResult = document.querySelectorAll(".js-quiz-color-result");
    productQuizColorResult.forEach((element) => {
      element.textContent = color;
    });

    // Find and click the color swatch in the new variant-picker structure
    const colorSelectors = [
      `.option-selector__btns input[value="${color}"]`,
      `.option-selector__btns input[data-value="${color}"]`,
      `.option-selector__btns label[title="${color}"]`,
      `.swatch-label[title="${color}"]`,
    ];

    let colorSwatch = null;
    for (const selector of colorSelectors) {
      colorSwatch = document.querySelector(selector);
      if (colorSwatch) break;
    }

    if (colorSwatch) {
      setTimeout(() => {
        // If it's an input, check it; if it's a label, click it
        if (colorSwatch.tagName === 'INPUT') {
          colorSwatch.checked = true;
          colorSwatch.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          colorSwatch.click();
        }
        
        showProduct();
        console.log(`Color "${color}" selected`);
      }, 250);
    } else {
      console.warn(`Color swatch for "${color}" not found. Tried selectors:`, colorSelectors);
      showProduct();
    }
  };

  const initializeScrollButtonsForStep = (step) => {
    const quizStep = quizSteps[step];
    const quizAnswers = quizStep.querySelector(".quiz-answers");
    const leftButton = quizStep.querySelector(".scroll-button--left");
    const rightButton = quizStep.querySelector(".scroll-button--right");

    const updateScrollButtons = () => {
      leftButton.disabled = quizAnswers.scrollLeft === 0;
      rightButton.disabled =
        quizAnswers.scrollLeft + quizAnswers.offsetWidth >=
        quizAnswers.scrollWidth;
    };

    leftButton.addEventListener("click", () => {
      const itemWidth =
        quizAnswers.querySelector(".quiz-answer").offsetWidth + 40;
      quizAnswers.scrollBy({ left: -itemWidth, behavior: "smooth" });
    });

    rightButton.addEventListener("click", () => {
      const itemWidth =
        quizAnswers.querySelector(".quiz-answer").offsetWidth + 40;
      quizAnswers.scrollBy({ left: itemWidth, behavior: "smooth" });
    });

    quizAnswers.addEventListener("scroll", updateScrollButtons);
    updateScrollButtons();
  };

  const initializeScrollButtons = () => {
    quizSteps.forEach((step, index) => initializeScrollButtonsForStep(index));
  };

  quizSteps.forEach((stepElement, stepIndex) => {
    const inputs = stepElement.querySelectorAll("input");
    const nextButton = stepElement.querySelector(".next-button");
    const previousButton = stepElement.querySelector(".previous-button");

    updateButtonState(stepIndex);
    updatePreviousButtonState(stepIndex);

    inputs.forEach((input) => {
      input.addEventListener("change", () => updateButtonState(stepIndex));
    });

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        saveStepResult(stepIndex);
        if (stepIndex < quizSteps.length - 1) {
          currentStep += 1;
          showStep(currentStep);
        } else {
          console.log("Quiz Results:", quizResults);
          computeOptionCounts();
        }
      });
    }

    if (previousButton) {
      previousButton.addEventListener("click", () => {
        if (stepIndex > 0) {
          currentStep -= 1;
          showStep(currentStep);
        }
      });
    }
  });

  showStep(currentStep);
  initializeScrollButtons();
  initializeModalButtons();
});

document.addEventListener("DOMContentLoaded", () => {
  // Wait a bit for the quiz product block to be rendered
  setTimeout(() => {
    const addToCartButton = document.querySelector(
      '#quiz-product .js-product-form button[name="add"]'
    );
    
    if (addToCartButton) {
      addToCartButton.addEventListener("click", () => {
        if (window.gtag) {
          gtag("event", "quiz_add_to_cart", {
            quiz_step: "add_to_cart",
            quiz_type: "shade_finder",
          });
          console.log("✅ Quiz add to cart event sent to Google Analytics");
        } else {
          console.warn("❌ GTM undefined for add to cart event");
        }
      });
    } else {
      console.warn("Add to cart button not found for quiz GTM tracking");
    }
  }, 500);
});
